import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="auto-container">
        <div className="widget-section">
          <div className="row clearfix">

            {/* About Widget */}
            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget logo-widget">
                <div className="widget-title">
                  <h3>About</h3>
                </div>
                <p>
                  We deliver accurate, culturally sensitive translation services to help businesses and individuals communicate effectively across regions and languages.
                </p>
              </div>
            </div>

            {/* Quick Links Widget */}
            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget links-widget ml_60">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                </div>
                <div className="widget-content">
                <ul className="links-list clearfix">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/translations">Translations</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
                </div>
              </div>
            </div>

            {/* Contact Info Widget */}
            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget links-widget">
                <div className="widget-title">
                  <h3>Contact Info</h3>
                </div>
                <div className="widget-content">
                  <li>
                    <a
                      href="https://maps.app.goo.gl/x3JY6C8fptv5SJWv7"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#fff' }}
                    >
                      Address: 114 2nd Cross Rd,<br /> Wattala, Sri Lanka
                    </a>
                  </li>
                  <br />
                  <li>
                    <a href="tel:94-11-2655017" style={{ color: '#fff' }}>
                      Phone: 94-11-2655017
                    </a>
                  </li>
                  <br />
                  <li>
                    <a href="mailto:info@wications.com" style={{ color: '#fff' }}>
                      Email: info@wications.com
                    </a>
                  </li>
                </div>
              </div>
            </div>

            {/* Location Map Widget */}
            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
              <div className="footer-widget subscribe-widget">
                <div className="widget-title">
                  <h3>Location</h3>
                </div>
                <div className="widget-content">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.146245259039!2d79.8818654747577!3d6.9920503930090385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2f7d0669a8f09%3A0x4975e69756667281!2s114%202nd%20Cross%20Rd%2C%20Wattala%2C%20Sri%20Lanka!5e0!3m2!1sen!2sin!4v1745078748926!5m2!1sen!2sin"
                    width="300"
                    height="180"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Wications Location"
                  ></iframe>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom centred">
        <div className="auto-container">
          <div className="copyright">
            <p>Copyright &copy; {new Date().getFullYear()} Wications | All Rights Reserved</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;